module.exports = __webpack_public_path__ + "static/media/h5备份 4.040e3275.jpg";